<script setup>
import FeatherIcon from './FeatherIcon.vue';
const props = defineProps({
  theme: { type: String, required: true },
});
const emit = defineEmits(['themeChanged']);

function toggleTheme() {
  const newTheme = props.theme === 'light' ? 'dark' : 'light';
  localStorage.setItem('theme', newTheme);
  emit('themeChanged', newTheme);
}
</script>

<template>
  <a href="#" @click.prevent="toggleTheme" aria-label="Theme Switcher">
    <FeatherIcon v-if="props.theme === 'light'" name="moon" iconClass="w-5 text-liText-ternary-dark hover:text-gray-400 dark:text-liText-ternary-light dark:hover:text-liBorder-primary-light" />
    <FeatherIcon v-else name="sun" iconClass="w-5 text-gray-200 hover:text-gray-50" />
  </a>
</template>
